import React from "react";

import styles from "./LoadingDots.css";

const LoadingDots = () => {
  return (
    <div className={styles.root}>
      <div className={styles.dot}>·</div>
      <div className={styles.dot}>·</div>
      <div className={styles.dot}>·</div>
    </div>
  );
};

export default LoadingDots;
